import { JSX } from "react";

export const Icon = (): JSX.Element => {
    return (
        <img
            src='/selector/chevron.svg'
            alt='arrow logo'
            style={{
                marginRight: 14,
            }}
        />
    );
};
